/* istanbul ignore file */
import { gql } from '@ori/fetching';
import { shades } from './fragments';
export const getProductShades = gql`
  ${shades}
  query GetProductShades($productCode: ID!) {
    product(productCode: $productCode) {
      pdpUrl {
        relativeUrl
      }
      concept {
        name
        products {
          ...ShadePickerShade
        }
      }
    }
  }
`;
//# sourceMappingURL=pruductShades.js.map